<template>
  <div v-if="Object.values(latestData).some(dataPoint => dataPoint !== null)">
    <div class="time">
      {{ $t('general.dashboards.collectedOn') }}
      {{ latestPointTime }}
    </div>
    <div
      class="grid"
      :class="responsiveClass"
    >
      <v-my-card
        v-for="key in keys"
        :key="key.name"
        class="cell"
      >
        <h3>
          {{ key.label }}
        </h3>
        <div
          :style="{ backgroundColor: key.color }"
          class="circle"
        />
        <span class="value">
          {{ latestData[key.queryKey].value != null ? key.formatter(latestData[key.queryKey].value) : '-' }}
        </span>
        <span class="unit">
          {{ key.measure }}
        </span>
      </v-my-card>
    </div>
  </div>
</template>

<script>
import VMyCard from '@/components/Card.vue';
import { DateTime } from 'luxon';

export default {
  name: 'LatestData',
  components: {
    VMyCard,
  },
  props: {
    latestData: {
      type: Object,
      required: true,
    },
    keys: {
      type: Array,
      required: true,
    },
  },
  computed: {
    responsiveClass() {
      if (this.$vuetify.breakpoint.smAndDown) return 'smAndDown';
      if (this.$vuetify.breakpoint.mdAndDown) return 'mdAndDown';
      return 'lg';
    },
    latestPointTime() {
      const dateTime = DateTime.fromISO(Object.values(this.latestData)[0].time);
      if (dateTime.isValid) {
        return dateTime.toLocaleString(DateTime.DATETIME_SHORT);
      }
      return '-';
    },
  },
};
</script>

<style scoped>
.mdAndDown {
  grid-template-columns: repeat(2, 1fr);
}

.smAndDown {
  grid-template-columns: 1fr;
}

.lg {
  grid-template-columns: repeat(4, 1fr);
}

.time {
  font-size: 16px;
  color: #949CB2;
  margin-top: 20px;
  margin-bottom: 12px;
}

.grid {
  display: grid;
  gap: 18px;
}

.cell {
  padding: 16px 12px;
  position: relative;
}

.value {
  font-size: 48px;
  font-weight: 600;
}

.unit {
  font-size: 14px;
  font-weight: 400;
}

.circle {
  position: absolute;
  right: 12px;
  top: 12px;
  width: 20px;
  height: 20px;
  border-radius: 10px;
}
</style>
